import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, CircularProgress, Divider, Drawer, useTheme } from '@mui/material';

import { NavItem, NavList, UserAvatar } from 'components';
import { authMobileSidebarMenuConfig, profileMobileSidebarMenuConfig } from 'configs';
import { ROUTES } from 'consts';
import { useAppDispatch, useAppSelector } from 'store/store.hook';
import { logout, selectCurrentUserInfo } from 'store/slices/auth.slice';
import { selectLayoutSlice, updateLayout } from 'store/slices/layout.slice';
import { ShoppingCart } from '@mui/icons-material';
import { useGetCountItemsInCartQuery } from '../../store/apis/decal-order.api';

interface AuthSidebarMenuMobileLayoutProps {}

export const AuthSidebarMenuMobileLayout: React.FC<AuthSidebarMenuMobileLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const { isAdmin, orgSlug, avatarUrl, name, title } = useAppSelector(selectCurrentUserInfo);
  const { authSidebarMenuOpened = false } = useAppSelector(selectLayoutSlice);
  const location = useLocation();
  const theme = useTheme();
  const navigate = useNavigate();

  const { data, isLoading: zonesCountLoading } = useGetCountItemsInCartQuery({ orgSlug });

  const closeSidebar = () => {
    dispatch(updateLayout({ authSidebarMenuOpened: false }));

    document.body.removeAttribute('style');
  };

  let activeLink = location.pathname;

  if (location.pathname === ROUTES.ZONES_ACTIVE || location.pathname === ROUTES.ZONES_INACTIVE) {
    activeLink = ROUTES.ZONES;
  }

  return (
    <Drawer anchor="right" open={authSidebarMenuOpened} onClose={() => closeSidebar()} sx={{ display: { md: 'none' } }}>
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          paddingTop: 3,
          paddingBottom: 2,
          paddingX: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <UserAvatar
          imageUrl={avatarUrl}
          name={name}
          title={title}
          vertical
          nameStyle={{ color: 'white', fontSize: 16, textAlign: 'center', marginTop: 2 }}
          titleStyle={{ color: 'white', fontSize: 12, textAlign: 'center' }}
        />

        <Button
          startIcon={zonesCountLoading ? <CircularProgress color="inherit" size={16} /> : <ShoppingCart />}
          endIcon={zonesCountLoading ? null : <>({data?.count})</>}
          sx={{ color: 'white', paddingX: 2, marginTop: 1 }}
          onClick={() => {
            navigate(ROUTES.REVIEW_CART);
            closeSidebar();
          }}
        >
          My Cart
        </Button>
      </Box>

      <Box sx={{ minWidth: 240, bgcolor: 'background.paper' }} paddingX={2} paddingY={4}>
        <NavList
          navItems={authMobileSidebarMenuConfig}
          direction="column"
          activeLink={activeLink}
          onNavItem={() => {
            closeSidebar();
          }}
        />

        {isAdmin && (
          <>
            <Box sx={{ paddingY: 3 }}>
              <Divider />
            </Box>

            <NavList
              navItems={profileMobileSidebarMenuConfig(orgSlug)}
              direction="column"
              activeLink={location.pathname}
              onNavItem={() => {
                closeSidebar();
              }}
            />
          </>
        )}

        <Box sx={{ paddingY: 3 }}>
          <Divider />
        </Box>

        <NavItem
          label={'Log Out'}
          align="left"
          onClick={() => {
            dispatch(logout());
            closeSidebar();
          }}
          style={{ width: '100%' }}
        />
      </Box>
    </Drawer>
  );
};
